import { render, staticRenderFns } from "./CommentDetail.vue?vue&type=template&id=c49feb4a&"
import script from "./CommentDetail.vue?vue&type=script&lang=js&"
export * from "./CommentDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommentDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VHover,VIcon,VTextField})
